<template>
  <div class="toolbar-page">
    <v-app-bar
      v-if="!$route.name.includes('website.live-view') || $vuetify.breakpoint.mdAndDown"
      app
      fixed
      flat
      color="white"
      class="d-lg-none"
    >
      <div class="d-flex align-center app-bar-container px-0" style="gap: 12px">
        <button class="primary--text btn-toogle-menu" icon @click.stop="drawer = !drawer">
          <Icon icon="gg:menu-left" :width="20" color="white" />
        </button>
        <router-link to="/admin" class="logo-mobile">
          <img src="/admin/img/logo.svg" alt="dropnoxe" />
        </router-link>
        <v-spacer></v-spacer>
        <v-menu v-if="user" offset-y rounded="lg">
          <template v-slot:activator="{ on }">
            <button v-on="on" class="d-flex align-center">
              <v-avatar :size="34" style="border: solid 1px var(--v-border-base)">
                <v-img v-if="user.profilePicture" :src="imageHelpers.url(user.profilePicture)" alt="Avatar" />
                <v-img v-else src="/admin/img/avatar.png" />
              </v-avatar>
              <div class="flex text-start pl-3 pr-1 d-none d-sm-block">
                <h4 class="primary--text">Seller</h4>
                <p class="mb-0" style="font-size: 14px; opacity: 0.8;">
                  {{ user.email }}
                </p>
              </div>
              <Icon icon="mingcute:down-line" :width="20" class="d-none d-sm-block" />
            </button>
          </template>
          <v-list class="py-0" dense>
            <v-list-item v-for="(action, index) in itemsLink" :key="index" class="px-3" @click="choseItem(action)" link>
              <v-list-item-title style="font-size: 14px; line-height: 20px; font-weight: 400;">{{
                action.title
              }}</v-list-item-title>
              <Icon :icon="action.icon" :width="20" />
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="choseItem('logout')" class="px-3" link>
              <v-list-item-title style="font-size: 14px; line-height: 20px; font-weight: 400;" class="error--text"
                >Sign out</v-list-item-title
              >
              <Icon icon="ion:log-out-outline" :width="20" class="error--text" />
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-app-bar
      v-if="!$route.name.includes('website.live-view') || $vuetify.breakpoint.mdAndDown"
      app
      fixed
      flat
      color="white"
      class="d-none d-lg-block"
    >
      <div class="d-flex align-center app-bar-container" style="gap: 32px">
        <v-spacer></v-spacer>
        <v-menu v-if="user" offset-y rounded="lg">
          <template v-slot:activator="{ on }">
            <button v-on="on" class="d-flex align-center">
              <v-avatar :size="34" style="border: solid 1px var(--v-border-base)">
                <v-img v-if="user.profilePicture" :src="imageHelpers.url(user.profilePicture)" alt="Avatar" />
                <v-img v-else src="/admin/img/avatar.png" />
              </v-avatar>
              <div class="flex text-start pl-3 pr-1">
                <h4 class="primary--text">Seller</h4>
                <p class="mb-0" style="font-size: 14px; opacity: 0.8;">{{ user.email }}</p>
              </div>
              <Icon icon="mingcute:down-line" :width="20" class="description--text" />
            </button>
          </template>
          <v-list class="py-0" dense>
            <v-list-item v-for="(action, index) in itemsLink" :key="index" class="px-3" @click="choseItem(action)" link>
              <v-list-item-title style="font-size: 14px; line-height: 20px; font-weight: 400;">{{
                action.title
              }}</v-list-item-title>
              <Icon :icon="action.icon" :width="20" />
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="choseItem('logout')" class="px-3" link>
              <v-list-item-title style="font-size: 14px; line-height: 20px; font-weight: 400;" class="error--text"
                >Sign out</v-list-item-title
              >
              <Icon icon="ion:log-out-outline" :width="20" class="error--text" />
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-navigation-drawer app fixed v-model="drawer" :width="220" height="100%">
      <template #prepend>
        <div class="px-3 d-flex align-center" style="height: 63px;">
          <router-link to="/admin" class="logo pt-2">
            <img src="/admin/img/logo.svg" alt="dropnoxe" />
          </router-link>
        </div>
        <v-divider />
      </template>
      <v-list class="navigation-menu" dense>
        <template v-for="(item, index) in items">
          <v-list-group v-if="isChildrens(item)" color="primary" :key="item.title">
            <template v-slot:activator>
              <v-list-item-icon class="mr-3">
                <Icon :icon="item.icon" :width="22" />
              </v-list-item-icon>
              <v-list-item-title>
                {{ $t(item.title) }}
              </v-list-item-title>
            </template>
            <template v-if="item.title === 'Online Store'" v-slot:appendIcon>
              <button @click="goToStore">
                <Icon icon="fluent:open-48-filled" :width="18" />
              </button>
            </template>
            <template v-for="(child, subIndex) in item.children">
              <v-list-item
                v-if="
                  (child.name === 'website.product-personalized' && !isDropship) ||
                    child.name !== 'website.product-personalized'
                "
                :key="subIndex"
                :class="currentPage === child.name && 'v-list-item--active'"
                @click="
                  utilities.checkPermisson(child.role, user)
                    ? changePage({
                        name: child.name,
                        params: child.params,
                        child: child.query,
                      })
                    : $router.push({ name: 'no-access' })
                "
                dark
              >
                <v-list-item-icon class="mr-3"><Icon icon="ph:dot-outline" :width="24"/></v-list-item-icon>
                <v-list-item-title>
                  {{ $t(child.title) }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list-group>
          <v-list-item
            v-else
            :key="index"
            @click="onClickNavigationItem(item)"
            color="primary"
            dark
            :class="currentPage === item.name && 'v-list-item--active'"
          >
            <v-list-item-icon class="mr-3">
              <Icon :icon="item.icon" :width="22" />
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
      <template #append>
        <router-link :to="{ name: 'website.terms-of-service' }" class="terms-link">
          Terms of Service
        </router-link>
      </template>
    </v-navigation-drawer>
    <v-dialog
      v-if="proxiesList.length === 0 && showWarning && loadedProxy && enableRef"
      v-model="notifyProxy"
      :width="480"
    >
      <v-card class="pa-4">
        <button class="close-icon" @click="notifyProxy = false">
          <v-icon>mdi-close</v-icon>
        </button>
        <h2 class="primary--text mb-2">Notify</h2>
        <p>
          Your store hasn't been configured with a payment gateway, please contact the administrator to set it up before
          publishing(run ads)!!!
        </p>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { payoutService } from '@/apis/payout';
import currency from '@/helpers/currency';
import MENU from '@/const/mockData';
import { mapGetters, mapState } from 'vuex';
import { authService } from '@/apis/auth.s';
import { apiConfig } from '@/apis/config.js';
import { imageFake } from '@/const/image';
import imageHelpers from '@/helpers/image';
import verifyMixin from '@/mixins/verify';
import utilities from '@/helpers/utilities';
import { apiProxy } from '@/apis/proxy';
import STORAGE_NAME from '@/const/storage';
import { domainService } from '@/apis/domain.s';
import { Icon } from '@iconify/vue2';

var timer;
var loadProxy;
export default {
  mixins: [verifyMixin],
  components: { Icon },
  data() {
    return {
      isShowStep: false,
      utilities,
      indexItem: '',
      drawer: true,
      mini: true,
      showWarning: true,
      notifyProxy: true,
      imageFake,
      imageHelpers,
      detailStep: {},
      proxiesList: [],
      loadedProxy: false,
      step: {},
      enableRef: false,
      isVip: false,
      itemsLink: [
        { title: 'Profile', router: 'website.profile', params: {}, icon: 'solar:user-rounded-outline' },
        {
          title: 'Select another store',
          router: 'auth',
          params: { authPage: 'shop' },
          icon: 'carbon:store',
        },
        { title: 'Open your site', router: '', params: {}, icon: 'fluent:open-48-filled' },
      ],
      paymentChoice: null,
      showImportFunc: false,
      whiteEmailList: ['support@dropnoxe.io', 'vmthd05@gmail.com', 'nhidy@alphax.com.vn', 'quynhpt@alphax.com.vn'],
    };
  },
  async created() {
    // this.getStep();
    // event.$on('getStepStatus', message => {
    //   this.getStep();
    // });
    this.checkEnableRef();
    this.updateProxyList('this.$store.state.auth?.user');
  },
  beforeMount() {},
  mounted() {
    this.updateBalance();
    this.paymentChoice = this.pagePreference?.paymentChoice?.type || 'seller';
    if (this.pagePreference && this.pagePreference.businessType === 'dropship') {
      this.isDrop = true;
    }
    this.showImportFunc = this.paymentChoice === 'seller' || (this.paymentChoice === 'latte' && !this.isDrop);
  },
  methods: {
    async loadBalance() {
      try {
        let res = await payoutService.getBalance();
        this.$store.commit('pagePreference/setBalance', res.data?.availableToPayout || 0);
      } catch (err) {}
    },
    async updateBalance() {
      if (timer) clearTimeout(timer);
      await this.loadBalance();
      timer = setTimeout(() => {
        this.updateBalance();
      }, 900000);
    },
    async loadProxy() {
      const storeId = localStorage.getItem(STORAGE_NAME.STORE_ID);
      const { data } = await apiProxy.get({
        limit: 10,
        page: 1,
        storeId: storeId,
      });
      this.proxiesList = data?.proxies;
      this.loadedProxy = true;
      if (!data?.store?.isEnabled) {
        this.$router.push({ name: 'policy-violation' });
        return;
      }
    },
    async updateProxyList() {
      if (loadProxy) clearTimeout(loadProxy);
      this.showWarning = true;
      this.notifyProxy = true;
      await this.loadProxy();
      if (this.proxiesList.length === 0) {
        loadProxy = setTimeout(() => {
          this.updateProxyList();
        }, 120000);
      }
    },
    async getStep() {
      try {
        let res = await apiConfig.getStatus();
        this.detailStep = res.data.currentConfig;
        if (this.detailStep.field === `domainConfigured`) {
          this.detailStep.description = this.detailStep.description.replace(
            `{domain}`,
            localStorage.getItem(`store-domain`),
          );
        }
        this.step = res.data;
        this.isShowStep = true;
      } catch (error) {}
    },
    clickStep() {
      this.$router.push({ path: `/${this.detailStep.path}` });
      this.isShowStep = false;
    },
    async checkEnableRef() {
      try {
        const checkEnableRef = await domainService.checkEnableRef();
        if (checkEnableRef) {
          this.enableRef = checkEnableRef.data[0].enableRef;
          this.isVip = checkEnableRef.data[0].isVip;
        }
      } catch (error) {
        this.errors = error;
      }
    },
    async skipStep() {
      try {
        if (this.detailStep.button !== `Back to Home`) {
          let res = await apiConfig.skipStep();
          this.detailStep = res.data.currentConfig;
          this.step = res.data;
        } else {
          this.isShowStep = false;
        }

        // await apiConfig.getStatus();
      } catch (error) {
        console.log('error', 'error', error);
      }
    },
    showStep() {
      this.isShowStep = !this.isShowStep;
    },
    openChildren(i) {
      console.log(1);
    },
    changePage(name) {
      this.$router.push(name);
      this.auth();
    },
    goToStore() {
      window.open('https://' + this.$store.state.auth.accountInfo.rDomain);
    },
    choseItem(item) {
      if (item === 'logout') {
        try {
          authService.logout();
          localStorage.clear();
          window.location.href = this.$urlAuth;
        } catch (error) {
          console.log(error.response);
        }
      } else if (item.title === 'Open your site') {
        window.open('https://' + this.$store.state.auth.accountInfo.rDomain);
      } else {
        this.$router.push({ name: item.router, params: item.params });
      }
      // if (item.title === 'Profile') {
      //   this.$router.push({ name: item.router, params: item.params });
      // }
      // if (item.title === 'Select another shop') {
      //   window.location.href = this.$urlAuth + 'shop';
      // }
    },
    isChildrens(item) {
      return (
        item.children &&
        item.children.length > 0 &&
        (!item.role || (item.role && utilities.checkPermisson(item.role, this.user)))
      );
    },
    onClickNavigationItem(item) {
      if (this.utilities.checkPermisson(item.role, this.user))
        this.changePage({ name: item.name, query: item.query, params: item.params });
      else this.$router.push({ name: 'no-access' });
    },
  },
  watch: {
    '$store.state.pagePreference.preference'() {
      let paymentChoice = this.pagePreference?.paymentChoice?.type || 'seller';
      this.showImportFunc = paymentChoice === 'seller' || (paymentChoice === 'latte' && !this.isDrop);
    },
  },
  computed: {
    balance() {
      let val = this.$store.state.pagePreference.balance || 0;
      return currency.priceFormat(val);
    },
    isDropship() {
      return this.pagePreference && this.pagePreference.businessType === 'dropship';
    },
    ...mapState({
      pagePreference: state => state.pagePreference.preference,
      currentSubscription: state => state.subscription.currentSubscription,
    }),
    ...mapGetters(['user', 'stores']),
    fullName() {
      if (!this.user?.firstName && !this.user?.lastName) return 'User';
      return this.user.firstName + ' ' + this.user.lastName || '';
    },
    currentPage: function() {
      const name = this.$route.name;
      if (name.includes('website.themes.homepage')) {
        return 'website.themes';
      }
      return this.$route.name;
    },
    activeGroup: function() {
      // dùng để filter $route.name nào  === với name trong mockData thì toggle nó xuống
      let group = this.items.find(
        item =>
          item.name == this.currentPage ||
          (item.children &&
            item.children.find(item => item.name == this.currentPage || this.currentPage.includes(item.name))),
      );
      if (group?.title == 'Online Store') {
        group.status = true;
      }
      if (
        group?.name == 'website.discount.code' ||
        group?.name == 'website.orders' ||
        group?.name == 'website.analytics' ||
        group?.name == 'website.products' ||
        group?.name == 'website.feeds'
      )
        group.status = true;
      return group;
    },
    isMobile() {
      return window?.innerWidth < 960;
    },

    items() {
      if (this.user?.email?.includes('homepage@dropnoxe.com')) {
        return MENU.menuHomePageSection;
      }
      const isEmailSuperUser =
        this.user?.email?.includes('abcabc@dropnoxe.com') ||
        this.user?.email?.includes('admin@dropnoxe.com') ||
        this.user?.email?.includes('d662seller@dropnoxe.com') ||
        this.user?.email?.includes('d210mktnta@dropnoxe.com') ||
        this.user?.email?.includes('nguyenvietxuan200@gmail.com');
      const isDnMember = this.currentSubscription && this.currentSubscription.code === 'DN_MEMBER';
      if (isEmailSuperUser || isDnMember) {
        const superMenu = MENU.menu.map(item => {
          // Chỉ super user theo email mới được chèn menu "Custom Homepage", DN_MEMBER thì không
          if (isEmailSuperUser && item.children && item.children.length > 0 && item.title === 'Online Store') {
            return {
              ...item,
              children: [
                ...item.children.slice(0, 1),
                {
                  title: 'Custom Homepage',
                  name: 'website.custom-homepage',
                  role: 'online_store',
                },
                ...item.children.slice(1),
              ],
            };
          }
          return item;
        });
        // const catalogsMenu = {
        //   title: 'Catalogs',
        //   icon: 'system-uicons:tags',
        //   name: 'website.catalog',
        //   type: 'only',
        //   role: 'catalogs',
        // };
        if (!isDnMember) {
          const overviewIndex = superMenu.findIndex(item => item.title === 'Overview');
          const menuWithCatalogs = [...superMenu];

          // if (overviewIndex >= 0) {
          //   menuWithCatalogs.splice(overviewIndex + 1, 0, catalogsMenu);
          // } else {
          //   menuWithCatalogs.push(catalogsMenu);
          // }

          return [
            ...menuWithCatalogs,
            {
              title: 'Apps',
              icon: 'fluent:apps-48-regular',
              name: 'website.apps',
              type: 'only',
              role: 'apps',
            },
          ];
        }
        return [
          ...superMenu,
          {
            title: 'Apps',
            icon: 'fluent:apps-48-regular',
            name: 'website.apps',
            type: 'only',
            role: 'apps',
          },
        ];
      }
      // const menus = this.isDropship ? MENU.dropMenu : MENU.menu;
      // if (this.whiteEmailList.indexOf(this.user?.email) >= 0) {
      //   if (!menus.find(item => item.title == 'Online Store')?.children.find(item => item.title == 'Themes')) {
      //     menus
      //       .find(item => item.title == 'Online Store')
      //       .children.push({
      //         title: 'Themes',
      //         name: 'website.themes',
      //         role: 'themes',
      //       });
      //   }
      // }
      // return menus;
      const filteredMenu = MENU.menu.filter(item => utilities.checkPermisson(item.role, this.user));
      // const filteredMenu = MENU.menu
      //   .map(item => {
      //     if (item.children) {
      //       const filteredChildren = item.children.filter(child => utilities.checkPermisson(child.role, this.user));
      //       return { ...item, children: filteredChildren };
      //     }
      //     return item;
      //   })
      //   .filter(item => !item.children || item.children.length > 0);
      return filteredMenu;
    },
  },
};
</script>
<style lang="scss" scoped>
.close-step {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
.logo {
  display: block;
  width: 100%;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
.logo-mobile {
  display: block;
  height: fit-content;
  padding-top: 4px;
  width: 132px;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
::v-deep .v-navigation-drawer__content {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
}
::v-deep .navigation-menu .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: var(--v-foreground-base) !important;
}
::v-deep .navigation-menu .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: var(--v-foreground-base) !important;
  .v-list-group__header__append-icon i {
    color: var(--v-foreground-base) !important;
  }
}
::v-deep .navigation-menu .v-list-item--active {
  &::before {
    background-color: transparent !important;
  }
}
::v-deep .v-toolbar__content {
  border-bottom: solid 1px var(--v-border-base);
  .app-bar-container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    height: 100%;
    padding-inline: 30px;
  }
}
.btn-toogle-menu {
  background-color: var(--v-primary-lighten2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.terms-link {
  color: black !important;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  padding: 8px 0;
  display: inline-block;
  transition: color 0.3s ease;
  width: 100%;
  text-align: center;
  text-decoration: underline;

  &:hover {
    color: #0fe7ba !important;
    text-decoration: underline;
  }
}
</style>
